export default __webpack_public_path__ + "static/media/home-but.43a30c56.svg";